import { useState, useMemo, useLayoutEffect, useEffect } from "react";
import { SLOT_SNAP, SLOT_TIME } from "../appointment-schedule.constants.js";
import { getTimeSlotDiference } from "../components/appointment/appointment.helpers.js";
const useAppointmentResize = ({ dragRef, onResize, onResizeStart, duration }) => {
  const [isResizing, setIsResizing] = useState(false);
  const [initialPosition, setInitialPosition] = useState(0);
  const [height, setHeight] = useState(0);
  const handleMouseUp = (event) => {
    event.stopPropagation();
    event.preventDefault();
    onResize == null ? void 0 : onResize(getTimeSlotDiference(height));
    setIsResizing(false);
    setInitialPosition(0);
    setHeight(0);
  };
  const handleMouseMove = (event) => {
    event.stopPropagation();
    const updatedHeight = Math.floor((event.clientY - initialPosition) / SLOT_SNAP) * SLOT_SNAP;
    if (duration + getTimeSlotDiference(updatedHeight) >= SLOT_TIME)
      setHeight(updatedHeight);
  };
  const timeDifference = useMemo(() => getTimeSlotDiference(height), [height]);
  useLayoutEffect(() => {
    if (dragRef.current) {
      dragRef.current.onclick = (event) => {
        event.stopPropagation();
        event.preventDefault();
      };
      dragRef.current.onmousedown = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setIsResizing(true);
        setInitialPosition(event.clientY);
        onResizeStart == null ? void 0 : onResizeStart();
      };
    }
  }, [dragRef.current]);
  useEffect(() => {
    if (isResizing) {
      window.document.addEventListener("mouseup", handleMouseUp);
      window.document.addEventListener("mousemove", handleMouseMove);
    } else {
      window.document.removeEventListener("mouseup", handleMouseUp);
      window.document.removeEventListener("mousemove", handleMouseMove);
    }
    return () => {
      window.document.removeEventListener("mouseup", handleMouseUp);
      window.document.removeEventListener("mousemove", handleMouseMove);
    };
  }, [initialPosition, height]);
  return {
    isResizing,
    height,
    timeDifference
  };
};
export {
  useAppointmentResize
};
